import ShowerCommon from "../showerNew/showerCommon";
import {createParentPositions, METADATA, ShowerHeadTypes} from "../../constants";
import store from "../../../../../store";
import {IS_QKB_UI} from "../../../../../config";

export default class ShowerArm extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_arm';
    this.partName = 'Shower Arm';
    this.translateId = "visualizer.bathroom.accessories.shower_arm";
    this.canBeDisabled = true;
    this.layerPriority = 8;
    // this.useMatchingFeatureReplacement = "MountPosition";
    if (isChild) {
      createParentPositions(this);
    }
  }

  navigationSubItems(...props) {
    if (IS_QKB_UI) {
      return this.navigationSubItemsWithSides(...props)
    }
    return super.navigationSubItems(...props);
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] || (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"][0] === "0")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    return super.load(dbFeature)
  }

  handleClick() {
    this.setArmHeadType();
    super.handleClick();
  }

  checkForSameMountPosition(newFeature) {
    if (newFeature.metaData["MountPosition"] || newFeature.metaData["MountType"]) {
      let conditions = [];
      if (newFeature.metaData["MountPosition"]) {
        conditions.push({
          propName: "MountPosition",
          propValue: newFeature.metaData["MountPosition"]
        });
      }
      if (newFeature.metaData["MountType"]) {
        conditions.push({
          propName: "MountType",
          propValue: newFeature.metaData["MountType"]
        });
      }
      Object.keys(this.layerPositions).forEach(position => {
        if ((position !== newFeature.metaData.layerPosition) && this.layerPositions[position]
          && !this.layerPositions[position].matchesMetaForArrayOfConditions(conditions)) {
          this.layerPositions[position] = null; // erase current position
        }
      })
    }
  }

  applyFeatureIfNotCompatible() {
    const showerParent = this.getParent().getParent();
    if (showerParent.showerFixture) {
      showerParent.showerFixture.disabled = true;
    }
  }

  disabledClick() {
    const showerHead = this.getParent().showerHead;
    if (showerHead) {
      showerHead.disabled = this.disabled || !showerHead.canBeEnabled(); // true or check if it can be enabled;
      if (showerHead.disabled && showerHead.layerPositions) {
        Object.keys(showerHead.layerPositions).forEach(position => {
          showerHead.layerPositions[position] = null;
        })
      }
    }
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm && this.activeFeature
  }

  setLayers(layout) {
    const showerParent = this.getParent();
    if (this.hideLayerCondition()) {
      super.hideLayers();
      return;
    }
    if (showerParent.showerHead && showerParent.showerHead.layerPositions && this.layerPositions && this.activeFeature) {
      Object.keys(showerParent.showerHead.layerPositions).forEach(position => {
        if (!this.layerPositions[position] && showerParent.showerHead.layerPositions[position]) {
          this.layerPositions[position] = this.getMatchingPositionFeature(position)
        } else if (this.layerPositions[position] && !showerParent.showerHead.layerPositions[position]) {
          const {wizardActiveItem} = store.getState().wizardState;
          if (!wizardActiveItem || !wizardActiveItem.hideItems) {
            this.layerPositions[position] = null
          }
        }
      })
    }
    return super.setLayers(layout);
  }

  canDisplayDemoPoint() {
    return this.getParent().shower_head_type === ShowerHeadTypes.shower_arm
  }

}
